import { Injectable, Injector } from "@angular/core";
import { Observable, catchError, of } from "rxjs";
import { SdkBase } from "../utilities/sdk-base/sdk.base";

@Injectable({ providedIn: 'root' })
export class ExternalAppUserClioSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public isLinked(): Observable<boolean | null> {
		return this.makeHttpRequest<boolean>('get', `api2/external-app-users/clio/isLinked`).pipe(
			catchError(() => {
				return of(null);
			}));
	}

	public delete(): Observable<boolean | null> {
		return this.makeHttpRequest<boolean | null>('delete', `api2/external-app-users/clio`).pipe(
			catchError(() => {
				return of(null);
			}));
	}
}
